import { useAppSelector } from "@app/hooks"
import { selectUserId } from "@app/data/appTokensStore"


export const useIsAuthorizedUser = (): boolean => {
  const credentials = useAppSelector(selectUserId)
   return !!credentials
}
